// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useLocation, Link } from "react-router-dom";
// import { AddToCart } from "../Pages/Products/AddtoCart";
// import { useWishlist } from "../../Context/WishlistContext";
// const PRODUCTS_API = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
// const CART_API = "https://ecom.cyberathon.com/index.php/Api/list_cart";
// function SearchResults() {
//   const { wishlistItems, toggleWishlist } = useWishlist();

//   const { search } = useLocation();
//   const query = new URLSearchParams(search).get("query") || "";

//   const [filtered, setFiltered] = useState([]);
// const [addedItems, setAddedItems] = useState([]);
// // ✅ LOAD CART ITEMS (IMPORTANT)
//   const loadCartItems = async () => {
//     const userId = sessionStorage.getItem("userId");
//     const cartToken = localStorage.getItem("cart_token");

//     if (!userId && !cartToken) return;

//     try {
//       const res = await axios.post(CART_API, {
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       });

//       if (res.data.status) {
//         const ids = res.data.cart_items.map((item) => item.prod_id);
//         setAddedItems(ids);
//       }
//     } catch (err) {
//       console.error("Cart load error", err);
//     }
//   };

//   const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);      
//     const hasHalfStar = rating % 1 !== 0;       
//     const emptyStars = 5 - Math.ceil(rating);   

//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
//     }
//     if (hasHalfStar) {
//       stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
//     }
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);
//     }

//     return stars;
//   };

// const handleAddToCart = async (prod_id) => {
//   try {
//     const res = await AddToCart(prod_id, 1);

//     if (res.data.status === true) {
//       setAddedItems(prev => [...prev, prod_id]);
//     } else {
//       alert(res.data.message);
//     }
//   } catch (err) {
//     console.error(err);
//     alert("Error while adding to cart");
//   }
// };

//   useEffect(() => {
//     axios.get(PRODUCTS_API).then((res) => {
//       const list = res.data.products || [];

//       const result = list.filter((item) =>
//         item.Product_name?.toLowerCase().includes(query.toLowerCase())
//       );

//       setFiltered(result);
//     });
    
//   loadCartItems(); 
//   }, [query]);

//   return (
//     <div className="container-fluid px-lg-5 px-3 py-3">
//       <h3>
//         Search Results for: <b>{query}</b>
//       </h3>
//       <hr />

//       {filtered.length === 0 ? (
//         <p>No products found.</p>
//       ) : (
//         <div className="row gapp">
//           {filtered.map((p) => (
//             <div className="col-6 col-sm-6 col-md-3 col-lg-3 mb-3" key={p.prod_id}>
//               <div className="card custom-card">

//                 <div className="position-relative">
//                   <Link to={`/DetailsSection3/${p.prod_id}`}>
//                   <img
//                     src={`https://ecom.cyberathon.com/${p.Product_image?.[0]}`}
//                     className="card-img-top"
//                     alt={p.Product_name}
//                   /></Link>
//                   <i
//   className={`position-absolute top-0 end-0 m-2 fs-5 px-2 py-1 shadow rounded-circle ${
//     wishlistItems.includes(p.prod_id)
//       ? "bi bi-suit-heart-fill text-danger bg-white"
//       : "bi bi-suit-heart text-white bg-dark bg-opacity-50"
//   }`}
//   style={{ cursor: "pointer", zIndex: 2 }}
//   onClick={(e) => {
//     e.stopPropagation();
//     toggleWishlist(p.prod_id);
//   }}
// ></i>

//                   <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
//                     {p.discount}% off
//                   </span>
//                 </div>

//                 {/* <div className="card-body text-start">
//                   <h6 className="fw-bold">{p.Product_name}</h6>
//                   <small>{p.discription}</small>

//                   <div className="d-flex gap-2 mt-1">
//                     <p className="text-success fw-bold mb-0">₹{p.current_price}</p>
//                     {p.old_price && (
//                       <small className="text-muted text-decoration-line-through">
//                         ₹{p.old_price}
//                       </small>
//                     )}
//                   </div>

                  
//                   <div
//   className="bg-col text-white fw-semibold py-2 rounded text-center"
//   style={{ cursor: addedItems.includes(p.prod_id) ? "default" : "pointer" }}
//   onClick={() =>
//     !addedItems.includes(p.prod_id) && handleAddToCart(p.prod_id)
//   }
// >
//   {addedItems.includes(p.prod_id) ? (
//     <>Added <span className="ms-2"><i className="bi bi-check2"></i></span></>
//   ) : (
//     <>Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span></>
//   )}
// </div>


//                 </div> */}
// <div className="card-body text-start">
//   <Link
//     to={`/DetailsSection3/${p.prod_id}`}
//     className="text-decoration-none text-dark"
//   >
//     <h6 className="fw-bold two-line-ellipsis product-title">
//       {p.Product_name}
//     </h6>

//     <small className="d-block desc-space one-line-ellipsis">
//       {p.discription ? p.discription : "\u00A0"}
//     </small>

//     <div className="price-space">
//       {p.current_price ? (
//         <>
//           <p className="text-success fw-bold mb-0">
//             ₹{p.current_price}
//           </p>
//           {p.old_price && (
//             <small className="text-muted text-decoration-line-through">
//               ₹{p.old_price}
//             </small>
//           )}
//         </>
//       ) : (
//         "\u00A0"
//       )}
//     </div>

//     <div className="rating-space">
//       {p.rating ? (
//         <>
//           {renderStars(p.rating)}
//           <small className="text-dark ms-1">
//             ({p.rating})
//           </small>
//         </>
//       ) : (
//         "\u00A0"
//       )}
//     </div>
//   </Link>

//   <div
//     className="bg-col text-white fw-semibold py-2 rounded text-center"
//     style={{
//       cursor: addedItems.includes(p.prod_id)
//         ? "default"
//         : "pointer",
//     }}
//     onClick={() =>
//       !addedItems.includes(p.prod_id) &&
//       handleAddToCart(p.prod_id)
//     }
//   >
//     {addedItems.includes(p.prod_id) ? (
//       <>
//         Added
//         <span className="ms-2">
//           <i className="bi bi-check2"></i>
//         </span>
//       </>
//     ) : (
//       <>
//         Add to Cart
//         <span className="ms-2">
//           <i className="bi bi-bag"></i>
//         </span>
//       </>
//     )}
//   </div>
// </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// export default SearchResults;













import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, Link } from "react-router-dom";
import { AddToCart } from "../Pages/Products/AddtoCart";
import { useWishlist } from "../../Context/WishlistContext";
import { useCart } from "../../Context/CartContext";

const PRODUCTS_API = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
const CART_API = "https://ecom.cyberathon.com/index.php/Api/list_cart";

// ★ SAME helpers jo product page (ProductsAPI2) me hai
const isProductOutOfStock = (product) => {
  if (!product.stock_status) return false;
  const status = String(product.stock_status).toLowerCase().trim();
  return (
    status === "out of stock" ||
    status === "out_of_stock" ||
    status === "outofstock" ||
    status === "0"
  );
};

const hasValidDiscount = (product) => {
  const offDiscount = Number(product.off_discount); // ★ discount nahi, off_discount use hoga
  return !isNaN(offDiscount) && offDiscount > 0;
};

function SearchResults() {
  const { wishlistItems, toggleWishlist } = useWishlist();
  const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

  const { search } = useLocation();
  const query = new URLSearchParams(search).get("query") || "";

  const [filtered, setFiltered] = useState([]);
  const [addedItems, setAddedItems] = useState([]);
  const [notifyRequested, setNotifyRequested] = useState({});
  const [notifyLoading, setNotifyLoading] = useState({});
  const [shareProduct, setShareProduct] = useState(null);
  const [shareUrl, setShareUrl] = useState("");

  // ✅ LOAD CART ITEMS (unchanged)
  const loadCartItems = async () => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = localStorage.getItem("cart_token");

    if (!userId && !cartToken) return;

    try {
      const res = await axios.post(CART_API, {
        user_id: userId ? userId : null,
        cart_token: userId ? null : cartToken,
      });

      if (res.data.status) {
        const ids = res.data.cart_items.map((item) => item.prod_id);
        setAddedItems(ids);
      }
    } catch (err) {
      console.error("Cart load error", err);
    }
  };

  // ★ product page jaisa description clean karne wala function
  const formatCardDescription = (html) => {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, " ")
      .replace(/\d+\./g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - Math.ceil(rating);

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
    }
    if (hasHalfStar) {
      stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);
    }

    return stars;
  };

  const handleAddToCart = async (prod_id) => {
    try {
      const res = await AddToCart(prod_id, 1);

      if (res.data.status === true) {
        setAddedItems((prev) => [...prev, prod_id]);
        setCartCount((prev) => prev + 1);
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Error while adding to cart");
    }
  };

  // ★ product page jaisa Notify Me (out of stock) logic
  const handleNotifyMe = async (product) => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      setRedirectAfterLogin(window.location.pathname);
      setShowLogin(true);
      return;
    }
    const prodId = product.prod_id;
    setNotifyLoading((prev) => ({ ...prev, [prodId]: true }));
    try {
      const res = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/add_stock_notification",
        {
          user_id: userId,
          prod_id: prodId,
          message: "Notify me when this product is back in stock",
        }
      );
      if (res.data.status === "true" || res.data.status === true) {
        setNotifyRequested((prev) => ({ ...prev, [prodId]: true }));
        alert("We will notify you when this product is back in stock.");
      } else {
        alert(res.data.message || "Failed to send notification");
      }
    } catch (err) {
      alert("Failed to send notification. Please try again.");
    } finally {
      setNotifyLoading((prev) => ({ ...prev, [prodId]: false }));
    }
  };

  // ★ product page jaisa Share popup
  const handleShare = (product) => {
    const baseUrl =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://shopeindia.co.in";
    setShareProduct(product);
    setShareUrl(`${baseUrl}/DetailsSection3/${product.prod_id}`);
  };

  // ══════════════════════════════════════════════
  // SEARCH LOGIC — bilkul unchanged, sirf grouping add ki (variants ke liye)
  // taaki price_type / quantity_set wale product bhi product-page jaisa hi behave kare
  // ══════════════════════════════════════════════
  useEffect(() => {
    axios.get(PRODUCTS_API).then((res) => {
      const list = res.data.products || [];

      const result = list.filter((item) =>
        item.Product_name?.toLowerCase().includes(query.toLowerCase())
      );

      // ★ same grouping jo ProductsAPI2 me hoti hai (size/variant merge)
      const grouped = {};
      result.forEach((item) => {
        if (!grouped[item.prod_id]) {
          grouped[item.prod_id] = { ...item, variants: [] };
        }
        if (item.size_id) {
          grouped[item.prod_id].variants.push({
            size_id: item.size_id,
            current_price: item.current_price,
            old_price: item.old_price,
          });
        }
      });

      setFiltered(Object.values(grouped));
    });

    loadCartItems();
  }, [query]);

  return (
    <div className="container-fluid px-lg-5 px-3 py-3">
      <h3>
        Search Results for: <b>{query}</b>
      </h3>
      <hr />

      <div className="row gapp">
        {filtered.length > 0 ? (
          filtered.map((p, index) => {
            const displayPrice =
              p.variant_price && p.variant_price !== "0.00"
                ? p.variant_price
                : p.current_price;
            const displayOldPrice =
              p.variant_old_price && p.variant_old_price !== "0.00"
                ? p.variant_old_price
                : p.old_price;

            return (
              <div
                className="col-6 col-sm-6 col-md-3 col-lg-3 mb-3"
                key={p.prod_id + "-" + index}
              >
                <div className="card custom-card">
                  <div className="position-relative">
                    <Link to={`/DetailsSection3/${p.prod_id}`}>
                      <img
                        src={`https://ecom.cyberathon.com/${p.Product_image?.[0]}`}
                        className="card-img-top mt-1"
                        alt={p.Product_name}
                      />
                    </Link>

                    <i
                      className={`position-absolute top-0 end-0 m-2 fs-5 px-2 py-1 shadow rounded-circle ${
                        wishlistItems.includes(p.prod_id)
                          ? "bi bi-suit-heart-fill text-danger bg-white"
                          : "bi bi-suit-heart text-white bg-dark bg-opacity-50"
                      }`}
                      style={{ cursor: "pointer", zIndex: 2 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleWishlist(p.prod_id);
                      }}
                    ></i>

                    <i
                      className="bi bi-share position-absolute top-0 start-0 m-2 fs-5 px-2 py-1 bg-white rounded-circle"
                      style={{ cursor: "pointer", zIndex: 2 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleShare(p);
                      }}
                    ></i>

                    {/* ★ Out of stock ya discount badge — product page jaisa */}
                    {isProductOutOfStock(p) ? (
                      <span
                        className="badge bg-danger position-absolute bottom-0 start-0 rounded-0"
                        style={{ fontSize: "0.75rem" }}
                      >
                        Out of Stock
                      </span>
                    ) : hasValidDiscount(p) ? (
                      <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
                        {p.off_discount}% off
                      </span>
                    ) : null}
                  </div>

                  <div className="card-body text-start">
                    <Link
                      to={`/DetailsSection3/${p.prod_id}`}
                      className="text-decoration-none text-dark"
                    >
                      {p.pdetails_sheading && (
                        <small className="d-block card-subheading one-line-ellipsis">
                          {p.pdetails_sheading}
                        </small>
                      )}

                      <h6 className="fw-bold two-line-ellipsis product-title">
                        {p.Product_name}
                      </h6>

                      <small className="d-block desc-space one-line-ellipsis">
                        {p.discription?.trim()
                          ? formatCardDescription(p.discription)
                          : "\u00A0"}
                      </small>

                      <div className="price-space">
                        {displayPrice ? (
                          <>
                            <p className="text-dark fw-bold mb-0">
                              ₹{displayPrice}
                            </p>
                            {displayOldPrice && (
                              <small className="text-muted text-decoration-line-through">
                                ₹{displayOldPrice}
                              </small>
                            )}
                          </>
                        ) : (
                          "\u00A0"
                        )}
                      </div>

                      <div className="rating-space">
                        {p.rating ? (
                          <>
                            {renderStars(p.rating)}
                            <small className="text-dark ms-1">({p.rating})</small>
                          </>
                        ) : (
                          "\u00A0"
                        )}
                      </div>
                    </Link>

                    {/* ★ Notify Me (out of stock) ya Add to Cart — product page jaisa */}
                    {isProductOutOfStock(p) ? (
                      <div
                        className={`py-2 rounded text-center fw-semibold ${
                          notifyRequested[p.prod_id]
                            ? "bg-secondary text-white"
                            : "notify-me-btn"
                        }`}
                        style={{
                          cursor:
                            notifyRequested[p.prod_id] || notifyLoading[p.prod_id]
                              ? "default"
                              : "pointer",
                        }}
                        onClick={() => {
                          if (!notifyRequested[p.prod_id] && !notifyLoading[p.prod_id])
                            handleNotifyMe(p);
                        }}
                      >
                        {notifyLoading[p.prod_id] ? (
                          <>
                            Sending... <i className="bi bi-arrow-repeat spin-icon ms-1"></i>
                          </>
                        ) : notifyRequested[p.prod_id] ? (
                          <>
                            Notification Sent <i className="bi bi-bell-fill ms-1"></i>
                          </>
                        ) : (
                          <>
                            Notify Me <i className="bi bi-bell ms-1"></i>
                          </>
                        )}
                      </div>
                    ) : (
                      (() => {
                        const hasVariants =
                          (p.variants && p.variants.length > 0) ||
                          p.price_type === "quantity_set";

                        const isAdded = hasVariants
                          ? false
                          : addedItems.includes(String(p.prod_id));

                        return (
                          <div
                            className="bg-col text-white fw-semibold py-2 rounded text-center"
                            style={{ cursor: isAdded ? "default" : "pointer" }}
                            onClick={() => !isAdded && handleAddToCart(p.prod_id)}
                          >
                            {isAdded ? (
                              <>
                                Added{" "}
                                <span className="ms-2">
                                  <i className="bi bi-check2"></i>
                                </span>
                              </>
                            ) : (
                              <>
                                Add to Cart{" "}
                                <span className="ms-2">
                                  <i className="bi bi-bag"></i>
                                </span>
                              </>
                            )}
                          </div>
                        );
                      })()
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No products found.</p>
        )}
      </div>

      {/* Share popup — product page jaisa */}
      {shareProduct && (
        <div className="share-overlay">
          <div className="share-popup">
            <div className="d-flex justify-content-between mb-3">
              <h5>Share Product</h5>
              <i
                className="bi bi-x-lg"
                style={{ cursor: "pointer" }}
                onClick={() => setShareProduct(null)}
              ></i>
            </div>
            <input type="text" value={shareUrl} readOnly className="form-control mb-3" />
            <div className="d-flex justify-content-around">
              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  shareProduct.Product_name + " " + shareUrl
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-whatsapp text-success fs-3"></i>
              </a>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(shareUrl);
                  alert("Link copied!");
                }}
              >
                <i className="bi bi-link-45deg fs-3"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchResults;